import type { ComponentPropsWithoutRef, ElementRef } from "react";
import { forwardRef } from "react";
import { RadioGroup } from "radix-ui";

import { tw } from "@/shared/utils";
import { SubscriptionItem, SubscriptionItemSkeleton } from "./sections";

const Root = forwardRef<
  ElementRef<typeof RadioGroup.Root>,
  ComponentPropsWithoutRef<typeof RadioGroup.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroup.Root
      className={tw("flex w-full flex-wrap justify-center gap-4", className)}
      {...props}
      ref={ref}
    />
  );
});
Root.displayName = "SubscriptionRadioGroup.Root";

export const SubscriptionRadioGroup = {
  Root,
  Item: SubscriptionItem,
  ItemSkeleton: SubscriptionItemSkeleton,
};
